"use client"

import type { Brief } from '../../hooks/use-briefs'
import { RecruiterSearchPanel } from './recruiter-search-panel'

interface BriefSearchTabProps {
  brief: Brief
  onEditBrief?: () => void
}

export function BriefSearchTab({ brief, onEditBrief }: BriefSearchTabProps) {
  return <RecruiterSearchPanel mode="brief" brief={brief} onEditBrief={onEditBrief} />
}
